import { connect } from "react-redux";
import { closeShareModal, openShareModal } from "actions/deal_modal";
import { connect as formikConnect } from "formik";
import { isBrokerSelector } from "selectors/currentUser";

import ShareStatus from "./ShareStatus";

const mapStateToProps = (state) => ({
  currentUser: state.currentUser,
  isBroker: isBrokerSelector(state),
  isShareModalOpen: state.dealModal.isShareModalOpen,
});

const mapDispatchToProps = (dispatch) => ({
  onCloseShareModal: () => dispatch(closeShareModal()),
  onOpenShareModal: () => dispatch(openShareModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(formikConnect(ShareStatus));
